import firebase from "firebase/compat/app"
import "firebase/compat/auth"
// import 'firebase/compat/firestore';

let app = firebase.initializeApp({
  apiKey: "AIzaSyAEI3Wh2J7aq_fva-sQCFxWM2gzsHyN7Rg",
  authDomain: "printverse-886ba.firebaseapp.com",
  projectId: "printverse-886ba",
  storageBucket: "printverse-886ba.firebasestorage.app",
  messagingSenderId: "889063925430",
  appId: "1:889063925430:web:ba7a208ace12a79fb66817",
  measurementId: "G-QH3Y1X8Y2Z"
  })


export const auth = app.auth()
export default app